<template>
  <div class="bg-dark">
    <Header />
    <div :v-if="mode === RESET_PASSWORD">
      <ForgotPasswordHeader :user-email="userEmail" />
      <div class="container-sm">
        <form
          class="standard-form"
          @submit="checkForm">
          <label for="password1">
            Your New Password
          </label>
          <input
            id="password1"
            v-model="newPassword"
            class="hero-input"
            type="password"
            placeholder="Your New Password"
            :disabled="successPasswordReset">
          <transition
            name="fade">
            <p
              v-if="error"
              class="danger-text absolute">
              {{ error }}
            </p>
          </transition>
          <button
            class="button button-primary mb-48 mt-48"
            type="button"
            :disabled="successPasswordReset"
            @click="submitPasswordForm">
            Change Password
          </button>
        </form>
        <transition name="fade">
          <p
            v-if="successPasswordReset"
            class="success-text">
            Nice! You've successfully reset your password. You can now login to Hero Hire using your new password.
          </p>
        </transition>
      </div>
    </div>
    <Footer
      :show-text="true"
      class="footer" />
  </div>
</template>

<script>
  import Header from '../components/Homepage/Header';
  import ForgotPasswordHeader from '../components/ForgotPassword/ForgotPasswordHeader';
  import Footer from '../components/GeneralViews/Footer';
  import firebase from '../scripts/firebase'

  export default {


    components: {
      Header,
      ForgotPasswordHeader,
      Footer
    },
    data() {
      return {
        userEmail: '',
        actionCode: '',
        mode: '',
        auth: '',
        newPassword: '',
        error: '',
        successPasswordReset: false,

        // Constants
        RESET_PASSWORD: 'resetPassword'
      }
    },
    created() {
      this.mode = this.$route.query.mode;
      this.actionCode = this.$route.query.oobCode;
    },
    mounted() {
      this.auth = firebase.auth();
      switch (this.mode) {
        case this.RESET_PASSWORD:
          this.handleResetPassword();
          break;
        default:
          this.$router.push({name: 'home'});
          break;
      }
    },
    methods: {
      handleResetPassword() {
        this.auth.verifyPasswordResetCode(this.actionCode).then(email => {
          this.userEmail = email
        }).catch(err => {
          console.log('Invalid or expired code - ' + err);
          this.$router.push({name: 'home'});
        })
      },
      checkForm(e) {
        if (this.newPassword) {
          return true;
        }
        if (!this.newPassword) {
          this.error = 'Oops! You need to enter a password here.'
        }
        e.preventDefault();
      },
      submitPasswordForm() {
        this.auth.confirmPasswordReset(this.actionCode, this.newPassword).then(res => {
          console.log('Success reset password!');
          this.successPasswordReset = true;
        })
            .catch(err => {
              console.error(`An error has occurred: ${err}`);
            })
      }
    }
  }
</script>

<style scoped>
  .bg-dark {
    background-color: #0b0d19;
  }

  .footer::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: block;
    height: 1px;
    background: #0b1524;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>
